import { useEffect, useState } from 'react';

import { TableContact } from '@/src/ContactsModule/interfaces/Interfaces';
import { ServiceMethods } from '@/src/infrastructure/Protocol/EmblueService';
import { useEmblue } from '@/src/infrastructure/Protocol/useEmblue';

export const useContactInfo = (emailId: number): [TableContact | undefined] => {
  const [contactInfo, setContactInfo] = useState<TableContact>();
  const [contactInfoValue] = useEmblue(ServiceMethods.getContactInfo, { emailId });

  useEffect(() => {
    if (contactInfoValue && !contactInfo) {
      setContactInfo(contactInfoValue.contactInfo);
    }
  }, [contactInfo, contactInfoValue]);

  return [contactInfo];
};
